Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedKeyboard = useAnimatedKeyboard;
var _react = require("react");
var _core = require("../core");
var _commonTypes = require("../commonTypes");
var _worklet_12775767243512_init_data = {
    code: "function anonymous(state,height){const{keyboardEventData}=this.__closure;keyboardEventData.state.value=state;keyboardEventData.height.value=height;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedKeyboard.ts",
    sourceMap: '{"version":3,"names":["anonymous","state","height","keyboardEventData","__closure","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedKeyboard.ts"],"mappings":"AAwBoD,QAAC,CAAAA,SAAOA,CAAAC,KAAM,CAAKC,MAAA,QAAAC,iBAAA,OAAAC,SAAA,CAEjED,iBAAiB,CAACF,KAAK,CAACI,KAAK,CAAGJ,KAAK,CACrCE,iBAAiB,CAACD,MAAM,CAACG,KAAK,CAAGH,MAAM,CACzC"}',
    version: "3.5.4"
};
var _worklet_4233221673031_init_data = {
    code: "function anonymous(state,height){const{_keyboardEventData}=this.__closure;_keyboardEventData.state.value=state;_keyboardEventData.height.value=height;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedKeyboard.ts",
    sourceMap: '{"version":3,"names":["anonymous","state","height","_keyboardEventData","__closure","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedKeyboard.ts"],"mappings":"AAoCsD,QAAC,CAAAA,SAAOA,CAAAC,KAAM,CAAKC,MAAA,QAAAC,kBAAA,OAAAC,SAAA,CAEjED,kBAAiB,CAACF,KAAK,CAACI,KAAK,CAAGJ,KAAK,CACrCE,kBAAiB,CAACD,MAAM,CAACG,KAAK,CAAGH,MAAM,CACzC"}',
    version: "3.5.4"
};
function useAnimatedKeyboard() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isStatusBarTranslucentAndroid: false
    };
    var ref = (0, _react.useRef)(null);
    var listenerId = (0, _react.useRef)(-1);
    var isSubscribed = (0, _react.useRef)(false);
    if (ref.current === null) {
        var keyboardEventData = {
            state: (0, _core.makeMutable)(_commonTypes.KeyboardState.UNKNOWN),
            height: (0, _core.makeMutable)(0)
        };
        listenerId.current = (0, _core.subscribeForKeyboardEvents)(function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous(state, height) {
                keyboardEventData.state.value = state;
                keyboardEventData.height.value = height;
            };
            anonymous.__closure = {
                keyboardEventData: keyboardEventData
            };
            anonymous.__initData = _worklet_12775767243512_init_data;
            anonymous.__workletHash = 12775767243512;
            anonymous.__stackDetails = _e;
            return anonymous;
        }(), options);
        ref.current = keyboardEventData;
        isSubscribed.current = true;
    }
    (0, _react.useEffect)(function() {
        if (isSubscribed.current === false && ref.current !== null) {
            var _keyboardEventData = ref.current;
            listenerId.current = (0, _core.subscribeForKeyboardEvents)(function() {
                var _e = [
                    new global.Error(),
                    -2,
                    -27
                ];
                var anonymous = function anonymous(state, height) {
                    _keyboardEventData.state.value = state;
                    _keyboardEventData.height.value = height;
                };
                anonymous.__closure = {
                    _keyboardEventData: _keyboardEventData
                };
                anonymous.__initData = _worklet_4233221673031_init_data;
                anonymous.__workletHash = 4233221673031;
                anonymous.__stackDetails = _e;
                return anonymous;
            }(), options);
            isSubscribed.current = true;
        }
        return function() {
            (0, _core.unsubscribeFromKeyboardEvents)(listenerId.current);
            isSubscribed.current = false;
        };
    }, []);
    return ref.current;
}
